export default {
  dialogPaper: {
    display: 'flex',
    flexDirection: 'column',
    maxHeight: '95vh',
    width: '600px',
    backgroundColor: '#f9f9f9',
    overflow: 'hidden'
  },
  dialogContent: {
    flex: '1 1 auto',
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
    minHeight: 0
  },
  label: {
    marginBottom: '15px',
    fontSize: '16px',
    flex: '1 1 auto',
    minHeight: 0,
    overflowY: 'auto',
    '@media (max-height: 500px)': {
      maxHeight: '110px',
      overflowY: 'auto',
      fontSize: '14px'
    }
  },
  bottomSection: {
    flexShrink: 0
  },
  rangeContainer: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: '8px',
    backgroundColor: '#ffffff',
    padding: '10px',
    borderRadius: '10px'
  },
  rangeTextContainer: {
    width: '100%'
  },
  rangeMainRow: {
    display: 'flex',
    alignItems: 'center'
  },
  icon: {
    marginRight: '10px',
    fontSize: '8px'
  },
  iconSuccess: {
    color: '#28a745'
  },
  iconError: {
    color: '#dc3545'
  },
  spinner: {
    marginLeft: 'auto'
  },
  successIcon: {
    marginLeft: 'auto',
    color: '#28a745'
  },
  errorIcon: {
    marginLeft: 'auto',
    color: '#dc3545'
  },
  errorDetail: {
    marginTop: '6px',
    marginLeft: '18px',
    fontSize: '13px',
    color: '#dc3545'
  },
  infoBox: {
    display: 'flex',
    padding: '10px',
    borderRadius: '8px',
    fontSize: '14px',
    marginTop: '10px',
    '@media (max-height: 500px)': {
      maxHeight: '80px',
      overflowY: 'auto'
    }
  },
  infoIcon: {
    marginRight: '8px',
    paddingTop: '3px'
  },
  footer: {
    display: 'flex',
    flexShrink: 0,
    justifyContent: 'center',
    margin: '10px 0',
    '& button': {
      marginRight: '10px'
    }
  }
};
